// @flow
import React, { Fragment, Component } from 'react';
import type { BlocContent } from 'types/NewsletterBloc';
import type { Status } from 'types/Status';
import type { CentenaireDocumentType, CentenaireClubPreviewType } from 'types/Centenaire';
import logo from 'assets/img/logo/centenaire_histoire.svg';
import { sendTags } from 'utils/tagManagerUtils';

import {
  STATUS_SUCCESS,
} from 'constants/statusConstants';

import { dynamicClassName } from 'utils/dynamicClassName';
import { Link } from 'react-router-dom';
import CentenaireSharePictureContainer from 'containers/centenaire/CentenaireSharePictureContainer';
import Description from 'components/fragments/text/Description';
import Breadcrumb from 'components/fragments/Breadcrumb';
import CentenaireSearchContainer from 'containers/centenaire/CentenaireSearchContainer';
import CentenaireCard from 'containers/centenaire/CentenaireCardContainer';

import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';

export type DispatchProps = {
  fetchClubsPreview: () => void,
  fetchCentenaireDocuments: (data: Object) => void,
  setQueryCentenaire: (query: string) => void,
};
export type StateProps = {
  title: string,
  description: Array<BlocContent>,
  meta_description: string,
  label: {
    id: number,
    name: string,
    slug: string
  },
  featured_media: {
    src: string,
    legend: string
  },
  status: Status,
  statusDocuments: Status,
  clubs: Array<CentenaireClubPreviewType>,
  documents: Array<CentenaireDocumentType>,
  total: number
};

type Props = StateProps & DispatchProps;

type State = {
  inputFocused: boolean,
  loading: boolean,
  redirect: boolean,
  pagination: number,
  keywords: Array<string>,
  documents: Array<CentenaireDocumentType>
};
class PageHubCentenaire extends Component<Props, State> {
  props: Props;
  masonry: any;
  _masonryContainer: ?HTMLElement;
  state: State = {
    inputFocused: false,
    loading: true,
    redirect: false,
    pagination: 0,
    keywords: ['Équipe de France', 'International', '1975', 'tournoi', 'R C Mans', 'Fédérale 1', 'Senior féminine'],
    documents: []
  };

  imagesLoaded() {
    if(this._masonryContainer) {
      imagesLoaded(this._masonryContainer, function(instance) {
        this.masonry.layout();
      }.bind(this));
    }
  }

  componentDidMount() {
    this.props.fetchClubsPreview();
    this.props.fetchCentenaireDocuments({});
    if (this._masonryContainer) {
      this.masonry = new Masonry(this._masonryContainer, {
        itemSelector: '.card--centenaire',
        gutter: 32,
        isAnimated: false
      });
      this.masonry.layout();
      this.imagesLoaded();
    }
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    const { statusDocuments } = this.props;
    if (prevProps.documents.length !== this.state.documents.length) {
      this.setState({documents: this.props.documents});
    }
    if (statusDocuments === STATUS_SUCCESS && !this.masonry) {
      this.masonry = new Masonry(this._masonryContainer, {
        itemSelector: '.card--centenaire',
        gutter: 32,
        isAnimated: false
      });
      this.masonry.layout();
      this.imagesLoaded();
    } else if (this.masonry) {
      this.masonry.reloadItems();
      this.masonry.layout();
      this.imagesLoaded();
    }
  }

  renderKeyword = () => {
    const { keywords } = this.state;
    /**
     * $FlowFixMe
     */
    const data = keywords.map((keyword, index) => {
      return (
        <li key={'keyword_'+index}>
          <Link
            to={{
              pathname: '/histoires-de-rugby/resultats-de-recherche',
              state: {
                queryCentenaire: keyword
              }
            }}
            onClick={() => {
              this.props.setQueryCentenaire(keyword);
              sendTags(
                'recherche_centenaire',
                'clic_filtres_les_plus_recherches',
                keyword,
              );
            }}
            className="link-club link-club--blue"
          >{keyword}</Link>
        </li>
      );
    });
    return data;
  }
  renderForm = () => {
    const {description, meta_description} = this.props;
    const classNamesInput = dynamicClassName('search-club col-md-12');
    this.state.inputFocused && classNamesInput.add('has-autocompletion');

    return (
      <form action="/histoires-de-rugby/resultats-de-recherche" className={classNamesInput.build()}>
        <img className="banner__img" src={logo} alt="Centenaire FFR" />
        <h1 className="ft-h2">{ 'Histoires de rugby' }</h1>
        {description && description.length > 0 &&
        <div className="banner__desc">
          <Description description={description}/>
        </div>}
        {(!description || description.length === 0) && meta_description &&
        <p className="banner__desc">
          {meta_description}
        </p>}
        <CentenaireSearchContainer
          clubs={this.props.clubs}
          handleInputClicked={this.handleInputClicked}
          handleClickOutside={this.handleClickOutside}
        />
        {this.state.keywords.length > 0 &&
        <div className="search-club__club">
          <p className="ft-h3 ft-400 mb-2">Les plus recherchés</p>
          <ul className="list-label mb-2">
            {this.renderKeyword()}
          </ul>
        </div>}
      </form>
    );
  };

  _renderContent = () => {
    const { statusDocuments, total, documents} = this.props;
    return (
      <Fragment>
        <div>
          {statusDocuments === STATUS_SUCCESS &&
          <p className={'mb-2 ft-white ft-h3 ft-400 col-md-12'}>À la une</p>}
          <div className='grid-centenaire__container col-md-12' ref={c => (this._masonryContainer = c)}>
            {this.renderDocuments()}
          </div>
        </div>
        {total > documents.length &&
          /**
           * TODO: transformer le lien en bouton (modfif dans le kit-ui)
           */
          <div className="grid-centenaire__more">
            <a href="#" 
              role="button" 
              tabIndex={0} 
              className="btn btn--primary btn--gold"
              onClick={(e) => this.handleClickMore(e)}>
              <span>Voir plus de souvenirs</span>
            </a>
          </div>
        }
      </Fragment>
    );
  }

  renderDocuments = () => {
    const { documents } = this.props;
    return documents.map<any>((document, index) => {
      return (
        <CentenaireCard {...document}
          key={`centenaire`+index} />
      );
    });
  }
  handleInputClicked = () => {
    this.setState({ inputFocused: true });
  };

  handleClickMore = (e: MouseEvent) => {
    e.preventDefault();
    const { documents, pagination} = this.state;
    this.props.fetchCentenaireDocuments({index: documents.length, documents: documents, mode: 'add'});
    this.setState({pagination: pagination + 1});
  }

  handleClickOutside = () => {
    this.setState({ inputFocused: false });
  };

  render() {
    const {
      featured_media,
      title,
    } = this.props;
    
    return (
      <Fragment>
        <section className="banner banner--searchCentenaire">
          <div className="banner__thumbnail" style={{ backgroundImage: `url(${featured_media.src})` }} />
          <div className="container">
            <Breadcrumb elements={[{ name: 'accueil', to: '/' }, title]} isDark />
            <CentenaireSharePictureContainer />
            {this.renderForm()}
          </div>
        </section>
        <div className={'grid-centenaire'}>
          <div className="container">
            {this._renderContent()}
          </div>
        </div>
      </Fragment>
    );
  }
}

export default PageHubCentenaire;
